import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StatCard } from "@/components/ui/stat-card";
import { Users, Clock, Phone } from "lucide-react";
import { AnalyticsData } from "@/services/analyticsService";

interface PerformanceStatsSectionProps {
  analytics: AnalyticsData;
  timeFrame: string;
  onTimeFrameChange: (value: string) => void;
}

export const PerformanceStatsSection: React.FC<
  PerformanceStatsSectionProps
> = ({ analytics, timeFrame, onTimeFrameChange }) => {
  return (
    <div className="mb-8 sm:mb-16">
      <Tabs
        defaultValue="30d"
        value={timeFrame}
        onValueChange={onTimeFrameChange}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Performance</h2>
          <TabsList className="bg-white bg-opacity-60">
            <TabsTrigger value="30d">Last 30D</TabsTrigger>
            <TabsTrigger value="all">All</TabsTrigger>
          </TabsList>
        </div>

        <div className="w-full">
          <TabsContent value="30d" className="space-y-0">
            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-4">
              <StatCard
                icon={Users}
                iconColor="text-brand-blue"
                label="Leads collected"
                value={analytics.leadsCollected}
              />
              <StatCard
                icon={Users}
                iconColor="text-brand-green"
                label="Assisted Customers"
                value={analytics.assistedCustomers}
              />
              <StatCard
                icon={Clock}
                iconColor="text-brand-purple"
                label="Time Saved"
                value={`${analytics.timeSaved}h`}
              />
              <StatCard
                icon={Phone}
                iconColor="text-brand-red"
                label="Voice Calls"
                value={analytics.voiceCalls}
              />
            </div>
          </TabsContent>

          <TabsContent value="all" className="space-y-0">
            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-4">
              <StatCard
                icon={Users}
                iconColor="text-brand-blue"
                label="Leads collected"
                value={analytics.leadsCollected}
              />
              <StatCard
                icon={Users}
                iconColor="text-brand-green"
                label="Assisted Customers"
                value={analytics.assistedCustomers}
              />
              <StatCard
                icon={Clock}
                iconColor="text-brand-purple"
                label="Time Saved"
                value={`${analytics.timeSaved}h`}
              />
              <StatCard
                icon={Phone}
                iconColor="text-brand-red"
                label="Voice Calls"
                value={analytics.voiceCalls}
              />
            </div>
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
